import type { Nullable } from 'corgi-types';
import type { User } from 'graphql-ts-types';
import { AuthenticationProvider } from 'graphql-ts-types';

import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Event } from 'common/types/auth';

export const trackLoginEvent = (user: Pick<User, 'visitorId' | 'visitorHash' | 'type'>) => {
  dispatchTrackingEventGA4({
    event: Event.LoginFormClick,
    interaction: 'Submit',
    success: 'Yes',
    provider: AuthenticationProvider.Home24Password,
    visitor_id: user.visitorId,
    visitor_hash: user.visitorHash,
    customer_type: user.type,
  });
};

export const trackLoginError = (message: Nullable<string>) => {
  dispatchTrackingEventGA4({
    event: Event.LoginFormClick,
    interaction: 'Submit',
    success: 'No',
    provider: AuthenticationProvider.Home24Password,
    name: 'serverError',
    message,
  });
};
